/**
 * About Text: parallax on secondary images.
 * Only runs if .about-text blocks exist.
 */
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export function initAboutTextParallax() {
	const blocks = document.querySelectorAll(".about-text");
	if (!blocks.length) return;

	blocks.forEach((block) => {
		const secondary1 = block.querySelector(".about-text__image--secondary-1");
		const secondary2 = block.querySelector(".about-text__image--secondary-2");

		if (secondary1) {
			gsap.to(secondary1, {
				y: -120,
				ease: "none",
				scrollTrigger: {
					trigger: block,
					start: "top 85%",
					end: "bottom 15%",
					scrub: 2,
				},
			});
		}
		if (secondary2) {
			gsap.to(secondary2, {
				y: -80,
				ease: "none",
				scrollTrigger: {
					trigger: block,
					start: "top 85%",
					end: "bottom 15%",
					scrub: 2,
				},
			});
		}
	});
}
